import { render, staticRenderFns } from "./card-user.vue?vue&type=template&id=e2fc5c00&scoped=true"
import script from "./card-user.vue?vue&type=script&lang=js"
export * from "./card-user.vue?vue&type=script&lang=js"
import style0 from "./card-user.vue?vue&type=style&index=0&id=e2fc5c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fc5c00",
  null
  
)

export default component.exports